module.exports = __webpack_public_path__ + "img/Srikanth Batni.295b69e8.jpg";